<template>
  <div>
    <!-- Error message if screener is blocked in visitor's country -->
    <v-alert
      v-if="screener.is_geo_blocked"
      v-model="geo_block_alert"
      dismissible
      type="error"
      class="mb-2"
      >{{ $t("screener.geo_blocked") }}</v-alert
    >
    <v-divider class="primary divider-custom-height"></v-divider>
    <v-card-text v-if="screener" class="px-0 secondary--text">
      <v-layout row wrap>
        <v-flex xs8 md9>
          <!-- Film title -->
          <div class="display-1 font-family-custom-heavy">
            {{ screener.title }}
            <v-spacer></v-spacer>
            <!-- Reserved checkmark -->
            <ReservedIndicator
              v-if="!screener.is_vod_event && isConsumerEnrolled(screener.id)"
            ></ReservedIndicator>
            <!-- Show "Purchased" mark if purchased but not enrolled  -->
            <PurchasedIndicator
              v-if="
                !screener.is_vod_event &&
                isConsumerPurchased(screener.id) &&
                !isConsumerEnrolled(screener.id)
              "
            ></PurchasedIndicator>
            <v-chip v-if="screener.is_vod_event && isVodEventExpired(screener.id)" small color="error" text-color="white">{{ $t("vod_event.expired") }}</v-chip>
            <v-chip v-if="screener.is_vod_event && isVodEventActive(screener.id)" small color="success" text-color="white">{{ $t("vod_event.active") }}</v-chip>
          </div>
          <!-- Zoom link -->
          <template v-if="screener.qa_info">
            <a
              v-if="screener.qa_info.title && screener.qa_info.zoom_link"
              :href="screener.qa_info.zoom_link"
              target="_blank"
              class="secondary--text font-weight-bold"
              >{{ screener.qa_info.title }}</a
            >
            <span
              v-else-if="screener.qa_info.title"
              class="secondary--text font-weight-bold"
              >{{ screener.qa_info.title }}</span
            >
          </template>
        </v-flex>
        <!-- Button -->
        <v-flex
          xs4
          md3
          :class="$vuetify.rtl ? 'text-xs-left' : 'text-xs-right'"
        >
          <template v-if="screener.allow_chat_room">
            <ChatContainer :screener="screener" :showBeInRegister="showBeInRegister"/>
          </template>
          <div v-if="$route.name != 'screeners.watch'">
            <ScreenerButton
              :screener="screener"
              @onBuyTicket="$emit('onBuyTicket', screener)"
              @onParticipate="$emit('onParticipate', screener)"
              @onWatch="$emit('onWatch', screener)"
              @onBuyVenueTicket="$emit('onBuyVenueTicket', screener)"
              class="d-inline-block"
            />
            <template v-if="showDonateBtn()">
              <v-btn
                :class="$vuetify.rtl ? 'ml-0' : 'mr-0'"
                color="primary background--text"
                @click="donationDialog = true"
                >{{ $t("paypal.donate.btn") }}</v-btn
              >
              <PayPalDonation
                :donationDialog.sync="donationDialog"
                :screener="screener"
                @resetDonationDialog="resetDonationDialog"
              />
            </template>
          </div>
          <div v-if="$route.name == 'screeners.watch' && screener.event_configuration.is_full_screen_mode">
            <v-btn @click="markFullScreenMode(true)" small color="success">
              {{ $t('watch.screen.page.enable.full.screen') }}
              <v-icon class="pl-2">mdi-fullscreen</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <!-- Screening date time -->
          <div class="subheading">
            <div class="d-inline-block">
              <span v-if="screener.is_vod_event" style="font-weight: bold">
                <span v-if="screener.is_event_started && !isVodEventExpired(screener.id)">
                  {{ $t("vod.event.expire.in") }}&nbsp;:&nbsp;
                  <span
                    >{{
                      moment
                        .utc(vodEventEndTime(screener.id))
                        .local()
                        .toNow(true)
                    }}
                    <b>(</b>
                    {{ vodEventEndTimeTZ }}
                    <b>)</b></span
                  >
                </span>
              </span>
              <span v-else style="font-weight: bold">
                {{ $t("screener.starts") }}&nbsp;:&nbsp;
                <span>
                  {{
                    moment.utc(screener.screening_starts_at).local().format("lll")
                  }}
                </span>
              <span>
                 <b>(</b>
                {{ startTimeByCompany }}
                <b>)</b>
              </span>
              <span v-if="screener.venue" class="px-1">|&nbsp;</span>
              </span>
            </div>
            <!-- <div v-if="screener.is_vod_event && screener.is_event_started" class="d-inline-block">
              <span
                v-if="
                  isConsumerEnrolled(screener.id) &&
                  vodEventEndTime(screener.id)
                "
              >
                {{
                  moment.utc(vodEventEndTime(screener.id)).local().format("lll")
                }}
              </span>
              <span>
                <b>(</b>
                {{ vodEventEndTimeTZ }}
                <b>)</b>
              </span>
              <span class="px-1">|&nbsp;</span>
            </div> -->
            <!-- <div v-else class="d-inline-block">
              {{
                moment.utc(screener.screening_starts_at).local().format("lll")
              }}
              <span>
                <b>(</b>
                {{ startTimeByCompany }}
                <b>)</b>
              </span>
              <span class="px-1">|&nbsp;</span>
            </div> -->
            <div class="d-inline-block">
              <span>{{ screener.venue }}</span>
            </div>

              <div v-if="screener.is_vod_event && !isConsumerSubscribed" >
                <span>{{$t('vod.header.price.label')}}</span>
                <h3 class="secondary--text d-inline-block">
                  {{
                    getCurrencySymbol(
                      screener.monetization[
                        DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE
                      ][0].currency
                    )
                  }}{{
                    screener.monetization[
                      DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE
                    ][0].price
                  }}
                  <span v-if="screener.vod_availability">{{ getHoursFormatted(screener.vod_availability) }}</span>
                </h3>
              </div>
          </div>

          <!-- Seats status -->
          <div
            v-if="$route.name != 'screeners.watch' && !screener.is_vod_event"
            class="pb-1"
          >
            <span style="font-weight: bold" class="subheading">{{
              $t("screener.seats.title")
            }}</span>
            <span class="subheading" v-html="getSeatsStatus(screener)"></span>
          </div>
          <!-- Event type -->
          <div
            v-if="$route.name != 'screeners.watch' && !screener.is_vod_event && screener.event_type > DEFINES.SCREENER_TYPE_VALUE.VIRTUAL"
            class="pb-1"
          >
            <span style="font-weight: bold" class="subheading">{{ $t(`screener.list.event.type`) }}</span>
            <v-chip small outline color="primary" class="ma-0">{{$t(DEFINES.SCREENER_TYPE_STR[screener.event_type])}}</v-chip>
          </div>
          <!-- Registration ends date -->
          <!-- <div
            v-if="$route.name != 'screeners.watch' && !screener.is_vod_event"
            class="caption"
          >
            <div class="d-inline-block">
              <span style="font-weight: bold"
                >{{ $t("screener.registration_ends") }}&nbsp;:&nbsp;</span
              >
            </div>
            <div v-if="!screener.is_vod_event" class="d-inline-block">
              {{
                moment.utc(screener.registration_ends_at).local().format("lll")
              }}
              <span>
                <b>(</b>
                {{ regEndTimeByCompany }}
                <b>)</b>
              </span>
            </div>
          </div> -->

          <!-- Custom URL -->
          <div
            v-if="
              screeningStarted && DEFINES.CUSTOM_URLS_ON_PLAYER[screener.id]
            "
          >
            <a
              :href="DEFINES.CUSTOM_URLS_ON_PLAYER[screener.id].url"
              target="_blank"
              class="secondary--text font-weight-bold"
              >{{ DEFINES.CUSTOM_URLS_ON_PLAYER[screener.id].text }}</a
            >
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider class="primary divider-custom-height"></v-divider>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { utcToTz } from "@/helpers";
import ScreenerButton from "@/components/screener/ScreenerButton";
import ReservedIndicator from "@/components/screener/ReservedIndicator";
import PurchasedIndicator from "@/components/screener/PurchasedIndicator";
import { getSeatsStatus } from "@/mixins/screening";
import PayPalDonation from "@/components/monetization/PayPalDonation";
import { currencySymbol } from "@/mixins/currencySymbol";

// Chatroom 
import ChatContainer from "@/components/chatRoom/ChatContainer"
// Chatroom 

export default {
  name: "ScreenerHeader",
  data: () => ({
    geo_block_alert: true,
    donationDialog: false,
  }),
  props: {
    screener: {
      type: Object,
      default: null,
    },
    screeningStarted: {
      type: Boolean,
      default: false,
    },
    showBeInRegister: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ScreenerButton,
    ReservedIndicator,
    PurchasedIndicator,
    PayPalDonation,
    ChatContainer
  },
  mixins: [getSeatsStatus, currencySymbol],
  computed: {
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      isConsumerPurchased: "isPurchased",
      vodEventStartTime: "getVodEventStartTime",
      vodEventEndTime: "getVodEventEndTime",
      isVodEventExpired: "isVodEventExpired",
      isVodEventActive: "isVodEventActive",
      isConsumerSubscribed: "isSubscribed"
    }),
    startTimeByCompany() {
      return utcToTz(
        this.screener.screening_starts_at,
        this.timezone,
        "MMM DD, YYYY HH:mm z"
      );
    },
    vodEventEndTimeTZ(date) {
      return utcToTz(
        this.vodEventEndTime(this.screener.id),
        this.timezone,
        "MMM DD, YYYY HH:mm z"
      );
    },
    regEndTimeByCompany() {
      return utcToTz(
        this.screener.registration_ends_at,
        this.timezone,
        "MMM DD, YYYY HH:mm z"
      );
    },
  },
  methods: {
    resetDonationDialog() {
      this.donationDialog = false;
    },

    showDonateBtn() {
      return (
        this.screener.donation_enabled &&
        this.isConsumerEnrolled(this.screener.id)
      );
    },
    async markFullScreenMode(value) {
      await this.$store.dispatch("app/setFullScreenMode", value);
    },
    getHoursFormatted(hours=0){
      let formatted = ''
      if(hours){
        if((hours >= 24)){
          formatted += this.$t('vod.header.for.label');
          let duration = this.moment.duration(this.screener.vod_availability, 'hours');
          /* Checking for years */
          if(duration.years()){
            let years = duration.years();
            let yLabel = (years > 1)?'for_years':'for_year';
            formatted += this.$t(`vod.header.${yLabel}.label`, {'years':years});
          }
          /* Checking for months */
          if(duration.months()){
            let months = duration.months();
            let mLabel = (months > 1)?'for_months':'for_month';
            formatted += this.$t(`vod.header.${mLabel}.label`, {'months':months});
          }
          /* Checking for days */
          if(duration.days()){
            let days = duration.days();
            let dLabel = (days > 1)?'for_days':'for_day';
            formatted += this.$t(`vod.header.${dLabel}.label`, {'days':days});
          }
        }else{
          let hLabel = (hours > 1)?'for_hours':'for_hour';
          formatted += this.$t(`vod.header.${hLabel}.label`, {'hours':hours});
        }
      }
      return formatted;
    }
  },
};
</script>

<style scoped>
.font-family-custom-heavy {
  font-family: "NarkissBlockTRIAL-Heavy" !important;
}
.float-right {
  float: right;
}
</style>
